import { createSelector } from 'reselect'
import { getThe, getTheBoolean, select } from 'src/store/selectors/utils'

const getTca = state => state.tca
const selectFromTca = select(getTca)

export const selectTcaSuccess = selectFromTca(getTheBoolean('success'))
export const selectTcaRequested = selectFromTca(getTheBoolean('requested'))
export const selectTcaError = selectFromTca(getThe('error'))
export const selectTcaLeadTimeHours = selectFromTca(getThe('leadTimeHours'))
export const selectTcaUpdated = selectFromTca(getTheBoolean('tcaUpdated'))

export const selectTcaReports = selectFromTca(getThe('reports'))
export const selectTcaReportForRefiDetails = details =>
  createSelector(
    selectTcaReports,
    reports =>
      reports ? reports[getTcaReportKeyFromRefiDetails(details)] : undefined
  )

export const getTcaReportKeyFromRefiDetails = ({ type, years }) =>
  `${type}_${years}`
